import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { EFavoritesType } from 'lib/types';
import { MarketTypes } from 'api/types';
import { IUserFavorite } from './use-favorite-list-item';

interface FavoritesSummarySchema {
  id: number;
  title: string;
  author: string;
  createdAt: string;
  updatedAt: string;
  facilitiesCount?: number;
  owners: IUserFavorite[];
  clients: IUserFavorite[];
}

const useFavoriteList = (payload: { marketType?: MarketTypes; types: EFavoritesType[] }) => {
  const { data, error, isLoading, ...rest } = useSWR(
    [`/favourites/list`],
    ([url]) =>
      fetcher.swr<FavoritesSummarySchema[]>(url, {
        method: 'post',
        data: {
          ...payload,
        },
      }),
    { errorRetryCount: 0, revalidateOnFocus: false },
  );

  return { favoriteList: data, error, isLoading, ...rest };
};

export default useFavoriteList;
